import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";

/**
 * Inline spinner + label, vertically centered with consistent spacing.
 * Drop-in replacement for the ad-hoc `<CircularProgress /> <Typography>Loading...</Typography>`
 * pairs that were misaligned and cramped across the app.
 *
 * `delay` (ms): render nothing until the delay elapses, so fast loads
 * (e.g. already-cached route chunks) never flash a spinner. Default 0
 * keeps existing call sites unchanged.
 */
export default function InlineLoader({
  label = "Loading...",
  size = 22,
  delay = 0,
}) {
  const [visible, setVisible] = React.useState(delay === 0);

  React.useEffect(() => {
    if (delay === 0) return undefined;
    const timer = setTimeout(() => setVisible(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);

  if (!visible) return null;

  return (
    <div
      role="status"
      aria-label={label || "Loading"}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 12,
      }}
    >
      <CircularProgress size={size} style={{ color: "#9b51e0" }} />
      {label ? <Typography className="header-h3">{label}</Typography> : null}
    </div>
  );
}
